// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-status-component {
  display: block;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.listing-status-component.fit-content {
  width: -moz-fit-content;
  width: fit-content;
}
.listing-status-component .status-label {
  min-width: 45px;
  min-height: 22px;
  border-radius: 5px;
  max-width: 80px;
  text-transform: uppercase;
  font-size: 8px;
  padding: 6px 8px;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  background-color: rgba(148, 148, 148, 0.2);
}
.listing-status-component .status-label.blue {
  color: #06C0CD;
  background-color: rgba(6, 192, 205, 0.2);
}
.listing-status-component .status-label.green {
  color: #36C313;
  background-color: rgba(54, 195, 19, 0.2);
}
.listing-status-component .status-label.mint {
  color: #1DD4A2;
  background-color: rgba(29, 212, 162, 0.1254901961);
}
.listing-status-component .status-label.orange {
  color: #FF7440;
  background-color: rgba(255, 115, 64, 0.1254901961);
}
.listing-status-component .status-label.gold {
  color: #BEB21A;
  background-color: rgba(190, 178, 26, 0.2);
}
.listing-status-component .status-label.grey {
  color: #808080;
  background-color: #F3F3F3;
}
.listing-status-component .status-checks {
  display: flex;
  justify-content: center;
}
.listing-status-component .status-checks > div {
  display: flex;
}
.listing-status-component .status-checks > div > span {
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.listing-status-component .status-checks > div > svg {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ListingStatus/listingStatus.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAEI;EAAgB,uBAAA;EAAA,kBAAA;AACpB;AAAI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0CAAA;AAER;AADQ;EACI,cAAA;EACA,wCAAA;AAGZ;AADQ;EACI,cAAA;EACA,wCAAA;AAGZ;AADQ;EACI,cAAA;EACA,kDAAA;AAGZ;AADQ;EACI,cAAA;EACA,kDAAA;AAGZ;AADQ;EACI,cAAA;EACA,yCAAA;AAGZ;AADQ;EACI,cAAA;EACA,yBAAA;AAGZ;AACI;EACI,aAAA;EACA,uBAAA;AACR;AAAQ;EACI,aAAA;AAEZ;AADY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAGhB;AADY;EACI,kBAAA;AAGhB","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.listing-status-component {\r\n    display: block;\r\n    flex-direction: column;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    &.fit-content { width: fit-content; }                                      \r\n    .status-label {\r\n        min-width: 45px;\r\n        min-height: 22px;\r\n        border-radius: 5px;\r\n        max-width: 80px;\r\n        text-transform: uppercase;\r\n        font-size: 8px;\r\n        padding: 6px 8px;\r\n        font-weight: 800;\r\n        white-space: nowrap; \r\n        overflow: hidden;\r\n        text-align: center;\r\n        text-overflow: ellipsis; \r\n        background-color: #94949433;\r\n        &.blue {\r\n            color: #06C0CD;\r\n            background-color: #06C0CD33;\r\n        }\r\n        &.green {\r\n            color: #36C313;\r\n            background-color: #36C31333;\r\n        }\r\n        &.mint {\r\n            color: #1DD4A2;\r\n            background-color: #1DD4A220;\r\n        }\r\n        &.orange {\r\n            color: #FF7440;\r\n            background-color: #ff734020;\r\n        }\r\n        &.gold {\r\n            color: #BEB21A;\r\n            background-color: #BEB21A33;\r\n        }\r\n        &.grey {\r\n            color: #808080;\r\n            background-color: #F3F3F3;\r\n        }\r\n\r\n    }\r\n    .status-checks {\r\n        display: flex;\r\n        justify-content: center;\r\n        > div { \r\n            display: flex;\r\n            > span {\r\n                font-size: 14px;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n            }\r\n            > svg {\r\n                align-self: center;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
